import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'htmlContent',
})
export class HtmlContentPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string): SafeHtml {
        if (!value) return '';

        // Заменяем <br> теги и декодируем HTML-сущности
        let processedValue = value.replace(/<br\s*\/?>/gi, '<br>');
        processedValue = processedValue.replace(/&lt;/g, '<');
        processedValue = processedValue.replace(/&gt;/g, '>');

        return this.sanitizer.bypassSecurityTrustHtml(processedValue);
    }
}
